import {ChangeDetectionStrategy, Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: "app-discussion-loading",
  templateUrl: "./discussion-loading.component.html",
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: "block p-3"},
})
export class DiscussionLoadingComponent {}
